import { Filed } from '@/modules/projects/components/Workbench/Filed'
import type { MapLane } from '@/modules/projects/components/Workbench/map'
import { FACTS_GRID } from '@/modules/projects/components/Workbench/mapLayout'
import { cn } from '@/utils'

export const BlockHeading = ({ filing }: { filing: MapLane | null }) => (
  <div className="mb-4">
    <p className="text-[13px] font-medium leading-5 text-foreground">
      Combined statements
    </p>
    <p className="text-xs text-ink-subtle">
      The bank prints these accounts on one statement.
    </p>
    {filing ? (
      <dl className={cn(FACTS_GRID, 'mt-1')}>
        <Filed filing={filing} />
      </dl>
    ) : null}
  </div>
)
